module.exports = __webpack_public_path__ + "assets/crying_face.2349cde099c7c9e2ec33f99859e34567c4851c374e326e7bd8663170bdb5be2b.png";